import classNames from 'classnames';
import React from 'react';
import * as styles from './PostSeriesMeta.module.scss';
import PopOver from '../../components/deprecated/PopOver';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import SeriesHoverCard from '../../series/SeriesHoverCard';

const SERIES_FIELDS_FRAGMENT = gql(`
  fragment PostSeriesMeta_series on SeriesFields {
    id
    name
    posts {
      id
    }
  }
`);

interface PostSeriesMetaProps {
  postId: string;
  series: DocumentType<typeof SERIES_FIELDS_FRAGMENT>;
  showHoverCard?: boolean;
  longHoverDelay?: boolean;
}

const PostSeriesMeta = ({
  postId,
  series,
  showHoverCard = false,
  longHoverDelay = false,
}: PostSeriesMetaProps) => {
  const index = series?.posts.findIndex(({ id }) => id === postId) ?? -1;
  if (!series || index < 0) {
    return null;
  }

  const inner = (
    <div
      className={classNames(styles.container, {
        [styles.hoverable]: showHoverCard,
      })}
    >
      {`Part ${index + 1} of ${series.name}`}
    </div>
  );

  return showHoverCard ? (
    <PopOver
      display="inline-block"
      placement="bottom-start"
      trigger="hover"
      longHoverDelay={longHoverDelay}
      popOverPortal={document.body}
      popOver={
        <PopOver.Container width="wide" noPadding>
          <SeriesHoverCard postId={postId} />
        </PopOver.Container>
      }
    >
      {inner}
    </PopOver>
  ) : (
    inner
  );
};

export default PostSeriesMeta;
